
export interface ClickRhythmRules {
  
  sampleSize: number;
  
  maxIntervalMs: number;
  
  toleranceMs: number;
}

export const CLICK_RHYTHM: ClickRhythmRules = {
  sampleSize: 12,
  maxIntervalMs: 5000,
  toleranceMs: 15,
};


export function isMachineRhythm(intervals: readonly number[], rules: ClickRhythmRules = CLICK_RHYTHM): boolean {
  if (intervals.length < rules.sampleSize) return false;
  const recent = intervals.slice(-rules.sampleSize);
  if (recent.some((interval) => interval <= 0 || interval > rules.maxIntervalMs)) return false;
  return Math.max(...recent) - Math.min(...recent) <= rules.toleranceMs * 2;
}


export class ClickRhythmTracker {
  private intervals: number[] = [];
  private last: number | null = null;
  private readonly rules: ClickRhythmRules;

  constructor(rules: ClickRhythmRules = CLICK_RHYTHM) {
    this.rules = rules;
  }

  
  record(time: number): boolean {
    if (this.last !== null) {
      const interval = time - this.last;
      if (interval > this.rules.maxIntervalMs) this.intervals = [];
      else {
        this.intervals.push(interval);
        if (this.intervals.length > this.rules.sampleSize) this.intervals.shift();
      }
    }
    this.last = time;
    return isMachineRhythm(this.intervals, this.rules);
  }
}
